import React from 'react';
import { FormRow, FormRowSelect } from '.'
import { useAppContext } from '../context/appContext';
import Wrapper from '../assets/wrappers/SearchContainer';

const  UserSearchContainer = () => {

    const {
        isLoading,
        search,
        searchType,
        sort,
        sortOptions,
        userTypeOptions,
        handleChange,
        clearFilters
    } = useAppContext();

    const handleSearch = (e) => {
        if (isLoading) return 
        handleChange({ name: e.target.name, value: e.target.value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        clearFilters();
    }

    return (
        <Wrapper>
            <form className='form'>
                <h4>search form</h4>
                <div className='form-center'>
                    {/* search userName */}
                    <FormRow
                        type='text'
                        name='search'
                        value={search}
                        handleChange={handleSearch}
                    ></FormRow>
                    {/* search by userType */}
                    <FormRowSelect
                        labelText='user type'
                        name='searchType'
                        value={searchType}
                        handleChange={handleSearch}
                        list={['all', ...userTypeOptions]}
                    ></FormRowSelect>
                    {/* sort */}
                    <FormRowSelect
                        name='sort'
                        value={sort}
                        handleChange={handleSearch}
                        list={sortOptions}
                    ></FormRowSelect>
                    <button className='btn btn-block btn-danger' disabled={isLoading} onClick={handleSubmit}>
                        clear filters
                    </button>
                </div>
            </form>
        </Wrapper>
    )
}

export default UserSearchContainer;